// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e286291f","513":"74dcc269","787":"a086a5b3"}[chunkId] + ".chunk.js";
};